module.exports = __webpack_public_path__ + "img/open_app.81947651.svg";